import { gql, useMutation } from '@apollo/client';

export const REMOVE_FROM_CONSOLIDATION = gql`
  mutation RemoveFromConsolidation($input: RemoveOrdersFromConsolidationTypeInput!) {
    removeOrdersFromConsolidation(input: $input) {
      success
      results {
        trackingNumber
        success
      }
      dissolvedBagCount
      message
    }
  }
`;

export interface RemoveFromConsolidationVariables {
  input: {
    warehouseId: string;
    trackingNumbers: string[];
  };
}

export interface RemoveFromConsolidationResponse {
  removeOrdersFromConsolidation: {
    success: boolean;
    results: Array<{
      trackingNumber: string;
      success: boolean;
    }>;
    dissolvedBagCount: number;
    message: string;
  };
}

export const useRemoveFromConsolidation = () => {
  return useMutation<RemoveFromConsolidationResponse, RemoveFromConsolidationVariables>(
    REMOVE_FROM_CONSOLIDATION
  );
}; 